<template>
    <header class="internal-header">
        <div class="pbb-container">
            <nav class="internal-header__breadcrumb" aria-label="Caminho de navegação">
                <router-link to="/">Início</router-link>
                <span aria-hidden="true">/</span>
                <router-link v-if="backTo" :to="backTo">{{ backLabel }}</router-link>
                <span v-else aria-current="page">{{ eyebrow }}</span>
            </nav>
            <span class="eyebrow">{{ eyebrow }}</span>
            <h1>{{ title }}</h1>
            <p v-if="description">{{ description }}</p>
            <div v-if="$slots.default" class="internal-header__actions"><slot /></div>
        </div>
    </header>
</template>
<script>
export default {
    name: 'InternalPageHeader',
    props: {
        title: { type: String, required: true },
        eyebrow: { type: String, default: 'PB&B' },
        description: { type: String, default: '' },
        backTo: { type: String, default: '' },
        backLabel: { type: String, default: 'Voltar' }
    }
};
</script>
